import { FetchApiKeys } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { ApiKeyState } from './types'

const getInitialState = (): ApiKeyState => ({
  apiKeys: [],
})

export const apiKeyReducer = (
  state: ApiKeyState = getInitialState(),
  action: Action<any>,
): ApiKeyState => {
  switch (action.type) {
    case FetchApiKeys.type.SUCCESS:
      return {
        ...state,
        apiKeys: action.payload,
      }
    default:
      return state
  }
}
